import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ClipboardService } from '../../services/clipboard.service';
import { DashboardComponent } from "../dashboard/dashboard.component";
import { AvatarProfileComponent } from "../../utilities/avatar-profile/avatar-profile.component";
import { AvatarComponent } from "../../components/avatar/avatar.component";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-single-customer',
  standalone: true,
  imports: [DashboardComponent, CommonModule, AvatarComponent],
  templateUrl: './single-customer.component.html',
  styleUrl: './single-customer.component.scss'
})
export class SingleCustomerComponent {
tabHeaders: string[] = ['Monthly Transactions', 'Reward Transactions'];
customerId: string = '';
activeTab: string = "Monthly Transactions";
constructor(private clipboardService: ClipboardService, private notification: NzNotificationService, private route: ActivatedRoute, private router: Router){}

ngOnInit() {
  this.route.params.subscribe((params) => {
    this.customerId = params['id'];
  });
}
navigateTo(data: any){
  this.router.navigate([`/${data}`]);
}
setActivetab=(value: string)=>{
  this.activeTab = value;
}
copyToClipboard(text: string) {
  this.clipboardService.copyToClipboard(text);
  this.notification.success(
    'Copied to clipboard',
    '',
    { nzClass: 'notification' }
  );
}
}
